module.exports = __webpack_public_path__ + "static/media/HotFeature005.d56aa478.png";